import React from 'react';
import BrandInfoTabView from './BrandInfoTabView';
import { useBrandInfoTabController } from '../../../controllers';
import { BrandInfoTabProps } from '../../../types';

const BrandInfoTab = (props: BrandInfoTabProps) => {
  const viewModel = useBrandInfoTabController(props);
  return <BrandInfoTabView {...viewModel} />;
};

export default BrandInfoTab;
